import { Color } from "./base-data";

const colors: Color[][] = [
  ["Y", "Y", "O", "O", "O", "G", "B", "B", "B", "Y", "Y", "R", "R", "G", "G"],
  ["O", "B", "B", "B", "R", "R", "R", "R", "R", "Y", "Y", "B", "R", "R", "O"],
  ["O", "O", "B", "B", "Y", "R", "O", "O", "O", "B", "B", "B", "R", "B", "B"],
  ["O", "G", "Y", "Y", "Y", "Y", "O", "G", "O", "B", "B", "O", "B", "B", "R"],
  ["G", "G", "G", "R", "Y", "O", "G", "G", "Y", "O", "O", "O", "O", "O", "R"],
  ["B", "G", "R", "G", "G", "O", "G", "Y", "G", "R", "R", "Y", "Y", "Y", "B"],
  ["R", "R", "R", "G", "B", "B", "Y", "Y", "G", "G", "G", "G", "G", "Y", "Y"],
];

const stars: boolean[][] = [
  [
    false,
    false,
    true,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    true,
    false,
    false,
    true,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    true,
    false,
    true,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    true,
  ],
  [
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
  ],
];

export const board = {
  colors,
  stars,
};
